const project = {
  slug: "starbit-crypto-platform",
  title: "STARBIT - Cryptocurrency Investment Platform",
  oneLiner: "Secure investing with KYC/AML, automated withdrawals, and real-time portfolio.",
  role: ["Web & App Lead", "Full-stack Engineer"],
  category: ["Web Development", "App Development"],
  clientOrOrg: "Starbit.lk",
  timeframe: { start: "2024-08", status: "In Progress" },
  domain: ["FinTech", "Crypto"],
  tech: ["React", "Laravel", "Flutter", "MySQL", "CI/CD"],
  links: { live: "https://starbit.lk", demo: "https://starbitdemo.hirun.lk", apk: "/assets/starbit/starbit-v7.apk" },
  gallery: [
    {
      src: "/assets/starbit/starbit-1.png",
      alt: "starbit-1"
    },
    {
      src: "/assets/starbit/starbit-2.png",
      alt: "starbit-2"
    },
    {
      src: "/assets/starbit/starbit-3.png",
      alt: "starbit-3"
    },
    {
      src: "/assets/starbit/starbit-4.png",
      alt: "starbit-4"
    }
  ],
  impact: [
    "Implemented KYC/AML, plan logic, profit tracking, and automated withdrawals.",
    "Reduced manual finance ops via role-based admin and payouts workflow."
  ],
  responsibilities: [
    "Architecture, database design, CI/CD and cloud storage integration",
    "Frontend (React) + Mobile (Flutter) + Backend APIs (NodeJS)"
  ],
  features: [
    "User onboarding & identity verification",
    "Subscription/plan management",
    "Portfolio & earnings dashboard",
    "Email/SMS alerts, audit logs"
  ],
  architecture: [
    "React web + Flutter mobile",
    "NodeJS REST APIs with RBAC",
    "MongoDB",
    "GitHub Actions CI/CD, Nginx"
  ],
  seo: {
    title: "STARBIT Crypto Platform - Full-stack Lead Case Study",
    description:
      "Built a secure crypto investing platform with KYC/AML, automated withdrawals, and real-time portfolios using React, NodeJS, Flutter, and MongoDB."
  },
  cover: "/assets/starbit/starbit-featured.png"
};

export default project;
